import React, { useEffect, useState } from "react";
import { groupBy } from "lodash";

import { SelectChangeEvent, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";

import { FilterBox, VariableCard } from "@/components/atoms";
import { useInsightFilters } from "@/context";
import { InsightResult } from "@/types";
import { filterScores } from "@/utils";

interface TvViewProps {
  scores: InsightResult[];
}

export const TvView: React.FC<TvViewProps> = ({ scores }) => {
  const {
    filters: { scoreType },
  } = useInsightFilters();

  const [selectedGroup, setSelectedGroup] = useState<string>('');
  const [selectedScores, setSelectedScores] = useState<InsightResult[]>([]);
  const [minMax, setMinMax] = useState<number[]>([0, 1]);

  const scoreGroups = Array.from(
    new Set(scores.map(x => x.tag_group))
  ).sort().map(x => ({name: x, label: x}));

  useEffect(() => {
    setSelectedGroup('TV Content');
  }, []);

  useEffect(() => {
    setSelectedScores(filterScores(scores, selectedGroup, scoreType.value));
  }, [scores, selectedGroup, scoreType.value]);

  useEffect(() => {
    const maxScore = Math.max.apply(
      Math,
      selectedScores
        .filter((x) => x.tag_name !== x.tag_category)
        .map((x) => Number(x[scoreType.value as keyof InsightResult])),
    );
    const minScore =
      scoreType.value === "rate"
        ? Math.min.apply(
          Math,
          selectedScores
            .filter((x) => x.tag_name !== x.tag_category)
            .map((x) => Number(x[scoreType.value as keyof InsightResult])),
        )
        : Math.max(1 - (maxScore - 1), 0);

    setMinMax([minScore, maxScore])
  }, [selectedScores, scoreType])

  const handleGroupSelect = (e: SelectChangeEvent) => {
    setSelectedGroup(e.target.value);
  }

  return (
    <>
      <Grid container size={12} spacing={2}>

        <FilterBox
          label="Group"
          value={selectedGroup}
          options={scoreGroups}
          onChange={handleGroupSelect}
          showSelected
          width={300}
        />

        {Object.entries(groupBy(selectedScores, 'tag_category')).map((category, idx) => (
          <Grid size={12} key={category[0]}>
            <Stack spacing={1} sx={{ mb: 1 }}>
              <Typography>{category[0]}</Typography>
              <Grid container size={12} spacing={1}>
                {category[1].map((variable, variableIdx) => (
                  <Grid key={`${category[0]}-${variableIdx}`}>
                    <VariableCard
                      name={variable.tag_name}
                      value={Number(variable[scoreType.value as keyof InsightResult])}
                      score={scoreType.value}
                      minValue={minMax[0]}
                      maxValue={minMax[1]}
                    />
                  </Grid>
                ))}
              </Grid>
            </Stack>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default TvView;
